import {Quote} from './Quote'
import {injectableClass} from '../utils/Utils'


@injectableClass("webtrader", "Account")
export class QuoteOption extends Quote {
  forecastProfitPercent(minutes) {
    if(this.constructor.Account.info.group.options_style != 'european')
      return this.win_full
    if (minutes < 5)
      return this.win_lt_5
    if (minutes < 15)
      return this.win_5
    if (minutes < 30)
      return this.win_15
    return this.win_30
  }

  forecastProfit(volume, minutes) {
    return this.forecastProfitPercent(minutes) * volume / 100
  }
}